export const badgeStyle = {
  fontWeight: 'bold',
  fontSize: 'sm',
  lineHeight: 'initial',
  marginX: 'xxxs',
  marginBottom: [0, 'md'],
  transform: 'translateY(2px)'
}

export const iconStyle = {
  color: 'brand',
  '& > path + path': { fill: 'white' }, // This is the 'circle' around the icon
  mr: 'xxxs',
  ml: '-3px',
  bg: 'white',
  borderRadius: '50%'
}
